import { render, staticRenderFns } from "./data38.vue?vue&type=template&id=e9603828&scoped=true"
import script from "./data38.vue?vue&type=script&lang=js"
export * from "./data38.vue?vue&type=script&lang=js"
import style1 from "./data38.vue?vue&type=style&index=1&id=e9603828&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9603828",
  null
  
)

export default component.exports